import { EVENT_COLLECTOR_END_POINT } from '../constants'
import { WebEventCollector } from '../interfaces/api/WebEventCollector'
import { CollectableEvent } from '../interfaces/event'
import { DoctorClickedEvent } from '../interfaces/event/DoctorClicked'
import { DoctorPageViewedEvent } from '../interfaces/event/DoctorPageViewed'
import { DoctorViewedEvent } from '../interfaces/event/DoctorViewed'
import { HospitalClickedEvent } from '../interfaces/event/HospitalClicked'
import { HospitalPageViewedEvent } from '../interfaces/event/HospitalPageViewed'
import { HospitalViewedEvent } from '../interfaces/event/HosptialViewed'
import { ServiceOfferClickedEvent } from '../interfaces/event/ServiceOfferClicked'
import { ServiceOfferPageViewedEvent } from '../interfaces/event/ServiceOfferPageViewed'
import { ServiceOfferViewedEvent } from '../interfaces/event/ServiceOfferViewed'

function createFetchWebEventCollector({
  baseURL,
  requestInfo,
  requestInit,
}: {
  baseURL: string
  requestInfo?: Request
  requestInit?: RequestInit
}): WebEventCollector {
  function emitEvents(events: CollectableEvent[]) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch(`${baseURL}${EVENT_COLLECTOR_END_POINT}`, {
      ...requestInit,
      ...requestInfo,
      method: 'POST',
      body: JSON.stringify({ events }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  return {
    emitServiceOfferViewed(event: ServiceOfferViewedEvent) {
      emitEvents([event])
    },
    emitServiceOfferClicked(event: ServiceOfferClickedEvent) {
      emitEvents([event])
    },
    emitServiceOfferPageViewed(event: ServiceOfferPageViewedEvent) {
      emitEvents([event])
    },

    emitHospitalViewed(event: HospitalViewedEvent) {
      emitEvents([event])
    },
    emitHospitalClicked(event: HospitalClickedEvent) {
      emitEvents([event])
    },
    emitHospitalPageViewed(event: HospitalPageViewedEvent) {
      emitEvents([event])
    },

    emitDoctorViewed(event: DoctorViewedEvent) {
      emitEvents([event])
    },
    emitDoctorPageViewed(event: DoctorPageViewedEvent) {
      emitEvents([event])
    },
    emitDoctorClicked(event: DoctorClickedEvent) {
      emitEvents([event])
    },
  }
}

export default createFetchWebEventCollector
